/* eslint-disable react-refresh/only-export-components -- co-locating Provider + hook for the style-profile context is intentional and matches names-context */
import { createContext, useContext, type ReactNode } from 'react';
import type { StyleProfile, StyleRule } from '@worldathletics/types';

import { resolveStyleRule } from './resolve-rule';

const StyleProfileContext = createContext<StyleProfile | null>(null);

type Props = {
  profile: StyleProfile | null;
  children: ReactNode;
};

export function StyleProfileProvider({ profile, children }: Props) {
  return (
    <StyleProfileContext.Provider value={profile}>
      {children}
    </StyleProfileContext.Provider>
  );
}

export function useStyleRule(style: string, depth: number): StyleRule | null {
  const profile = useContext(StyleProfileContext);
  return resolveStyleRule(profile, style, depth);
}
